import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import PoolPage from './pages/PoolPage';
import ResultsPage from './pages/ResultsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import FAQsPage from './pages/FAQsPage';
import StatsPage from './pages/StatsPage';
import { PageviewTracker } from './services/analytics';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <PageviewTracker />
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/admin/stats" element={<StatsPage />} />
            <Route path="/pool/:poolId" element={<PoolPage />} />
            <Route path="/results/:poolId" element={<ResultsPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
